<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div>
  <div>
     <div class="subheading pa-1 pl-2" style="font-weight: 400; text-transform: uppercase; background-color: rgba(5,151,110,0.3); text-align: center;">{{getNumberDisplay(vaccines) + ' Vaccines Administered In SA' }}</div>
  </div>
  <apexchart type="line" height="310" :options="chartOptions" :series="series" />
</div>
</template>

<script>
export default {
  name: "Vaccines",
  data: () => ({
    vaccines: 0,
    series: [
      {
        name: "Daily Vaccines",
        type: "column",
        data: []
      }
    ],
    chartOptions: {
      theme: {
        mode: "dark",
        palette: "palette10"
      },
      colors: [
        "#05976e"
      ],
      chart: {
        background: "rgb(28, 42, 82)",
        foreColor: "rgb(212, 212, 212)",
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false
          },
          autoSelected: "zoom"
        }
      },
      grid: {
        borderColor: "rgb(27, 36, 77)"
      },
      legend: {
        show: true,
        position: "bottom",
        itemMargin: {
          vertical: 10
        }
      },
      tooltip: {
        x: {
          show: true,
          format: "dd MMM"
        }
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
          dataLabels: {
            position: "top"
          }
        }
      },
      dataLabels: {
        enabled: false,
        enabledOnSeries: [0],
        style: {
          //fontSize: "12px",
          colors: ["#fff"]
        },
        background: {
          enabled: false
        }
      },
      markers: {
        size: 0
      },
      stroke: {
        width: [0, 3]
      },
      xaxis: {
        type: "datetime",
        //categories: [],
        labels: {
          style: {
            fontSize: "10px"
          }
        }
      },
      yaxis: [
        {
          title: {
            text: "Daily Vaccines"
          }
        }
      ]
    }
  }),
  methods: {
    loadCases(data, provinceDisplay) {
      this.series[0].data = [];

       var dates = [];
      //first get all the distinct dates
      dates = Array.from(new Set(data.map(cas => cas.date))).map(date => {
        return date;
      });

      //loop through dates and get daily vaccines
      var vaccVals = [];

      //loop through all the dates and find cases
      for (var i = 0; i < dates.length; i++) {
        var thisDate = dates[i];

        //get vaccines from National
        var matchVaccs = data.find(c => c.date === thisDate && c.region === "National")
        
        //if no vaccine data skip over that date
        if(matchVaccs.vaccines === "") {
          continue
        }

        //find previous cumulative count
        var prevInd = i - 1

        if(prevInd >= 0) {
          var prevDate = dates[prevInd]

          //vaccines
          var matchPrevVaccs = data.find(c => c.date === prevDate && c.region === "National")
          var diffVaccs = (matchVaccs.vaccines*1) - (matchPrevVaccs.vaccines*1)
         
          vaccVals.push([
            this.$moment(thisDate, "DD/MM/YYYY")
              .add(10, "hours")
              .toDate(),
           diffVaccs
          ]);
        }
        else {
          //push to arrays
          vaccVals.push([
            this.$moment(thisDate, "DD/MM/YYYY")
              .add(10, "hours")
              .toDate(),
            matchVaccs.vaccines*1
          ]);

        }         
      }

      //set the graph data
      this.series = [{
        name: "Daily Vaccines",
        type: "column",
        data: vaccVals
      }]

      //get the total count to date
      var lastCaseDate = dates[dates.length - 1]
      var vmatch = data.find(c => c.date === lastCaseDate && c.region === "National")
      this.vaccines = vmatch.vaccines*1
    },
    getNumberDisplay(number) {
      return number.toLocaleString('en').replace(/\,/g, ' ')   
    },
    resize() {
      let self = this;
      this.$nextTick().then(function() {
        self.chartOptions = {
          chart: {
            height: "310"
          }
        };
      });
    }
  }
};
</script>
